import { RuleListModel } from '../../models/RuleListModel';
import { IAutoSave } from '../../../pillar/workspace/IAutoSave';
import { AbstractControl } from '@angular/forms';
import { RuleParameterModel } from '../../models/RuleParameterModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const UPDATE_RULE_PARAMETER = '[Rule] Update Rule Parameter';

export class UpdateRuleParameterAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UPDATE_RULE_PARAMETER;

  constructor(public payload: {
    rule: RuleListModel,
    parameter: RuleParameterModel,
    control: IAutoSave & AbstractControl
  }) { }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/UpdateRuleParameterAction.ts